import { useMutation } from "@apollo/client";
import { Modal, Input, Form, Button } from "antd";
import { useForm } from "antd/lib/form/Form";
import React from "react";
import { GroupedEntityType } from "~/gql/graphql";
import { CREATE_GROUP_ITEM, GET_GROUP_ITEMS, UPDATE_GROUP_ITEM } from "./hooks/use-group-items";

type CreateGroupItemModalProps = {
  setModalState: (newState: boolean) => void;
  groupItemEntityType: GroupedEntityType;
  minimal?: boolean;
  parentId?: number;
  item?: { id: number; name: string };
};

export const CreateGroupItemModal: React.FC<CreateGroupItemModalProps> = ({
  setModalState,
  groupItemEntityType,
  minimal,
  parentId,
  item,
}) => {
  const [form] = useForm<{
    name: string;
    parentId: number;
  }>();

  const [createGroupItem] = useMutation(CREATE_GROUP_ITEM);
  const [updateGroupItem] = useMutation(UPDATE_GROUP_ITEM);

  const onCreate = async () => {
    try {
      const values = await form.validateFields();
      if (item) {
        updateGroupItem({
          variables: {
            id: item.id,
            updateInput: {
              name: {
                set: values.name,
              },
            },
          },
          refetchQueries: [
            { query: GET_GROUP_ITEMS, variables: { groupedEntityType: groupItemEntityType } },
          ],
          onCompleted: () => {
            setModalState(false);
          },
        });
      } else {
        createGroupItem({
          variables: {
            createInput: {
              name: values.name,
              description: values.name,
              parentId,
              entityType: groupItemEntityType,
            },
          },
          refetchQueries: [
            { query: GET_GROUP_ITEMS, variables: { groupedEntityType: groupItemEntityType } },
          ],
          onCompleted: () => {
            setModalState(false);
            form.resetFields();
          },
        });
      }
    } catch (errorInfo) {
      console.error("Validation Failed:", errorInfo);
    }
  };

  return minimal ? (
    <div style={{ display: "flex", margin: "0.5rem", marginBottom: 0 }}>
      <Form form={form} initialValues={item ? { name: item.name } : {}}>
        <Form.Item
          label="Title"
          name="name"
          rules={[{ required: true, message: "Please input title" }]}
        >
          <Input />
        </Form.Item>
      </Form>

      <Button style={{ marginLeft: 4 }} onClick={() => onCreate()}>
        {item ? "Update" : "Create"}
      </Button>
    </div>
  ) : (
    <Modal title="Title" open={true} onOk={() => onCreate()} onCancel={() => setModalState(false)}>
      <div>
        <Form form={form} initialValues={item ? { name: item.name } : {}}>
          <Form.Item
            label="Title"
            name="name"
            rules={[{ required: true, message: "Please input title" }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};
